module.exports = __webpack_public_path__ + "img/6.605a60fe.png";